import React from "react"

import { useComponentizedPage } from "store/contexts/componentized-page"
import { formatCurrency } from "utils/currency"

import { Container } from "./styles"

const ClassProductDescription = ({
  className,
  classId,
  headline,
  subheadline,
  description,
  dataId,
}) => {
  const { classesOnPage } = useComponentizedPage()

  const cls = classesOnPage.find((c) => c.classId === classId)
  if (!cls) return null

  return (
    <Container data-exp-id={dataId} className={className}>
      <h2 dangerouslySetInnerHTML={{ __html: headline || cls.title }} />
      <h3>{formatCurrency(cls.salePrice || cls.price, true)}</h3>
      {subheadline && <h4 dangerouslySetInnerHTML={{ __html: subheadline }} />}
      {cls.shortDescription && <h4 dangerouslySetInnerHTML={{ __html: cls.shortDescription }} />}
      {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
    </Container>
  )
}

export default ClassProductDescription
